module.exports = __webpack_public_path__ + "static/media/fs-logo.8af1dd05.svg";